<script>
import { mapActions, mapState } from "vuex";
import cryptoRandomString from "crypto-random-string";
import compKeluargaKatolik from "@/components/form/keluargaKatolik";
import compUmatModal from "@/components/modal/umat";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "keluargaKatolikForm",
	components: {
		"comp-keluarga-katolik": compKeluargaKatolik,
		"comp-umat-modal": compUmatModal,
	},
	data() {
		return {
			mode: "INSERT",
			isKepala: 1,
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
				hubungan: umatData.hubungan,
			},
			trigger: {
				keluargaKatolik: 0,
			},
			anggota: {
				hubungan_keluarga: "",
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			keluargaKatolikItem: (state) => state.keluargaKatolik.item,
			keluargaKatolikAnggota: (state) => state.keluargaKatolik.anggota,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
		baruLama: function () {
			return Object.assign({}, this.radio);
		},
	},
	created() {
		this.$store.dispatch("keluargaKatolik/resetItem");

		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			this.getItemKeluargaKatolik(this.$route.params.id).then(
				(response) => {
					this.setItemKeluargaKatolik(response.data.keluarga_katolik);
					this.setAnggota(response.data.anggota);
				},
				() => {
					this.$router.push("/keluarga_katolik");
				}
			);
		} else {
			this.keluargaKatolikItem.uid = cryptoRandomString({
				length: 32,
				type: "distinguishable",
			});
			this.autoFill();
		}
	},
	mounted() {
		this.getLingkunganStasi();
	},
	methods: {
		...mapActions({
			insert: "keluargaKatolik/insert",
			update: "keluargaKatolik/update",
			getItemKeluargaKatolik: "keluargaKatolik/getItem",
			setItemKeluargaKatolik: "keluargaKatolik/setItem",
			setAnggota: "keluargaKatolik/setAnggota",
			addAnggota: "keluargaKatolik/addAnggota",
			deleteAnggota: "keluargaKatolik/deleteAnggota",
			setKepala: "keluargaKatolik/setKepala",
			setItemUmat: "umat/setItem",
			getItemUmat: "umat/getItem",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		handleSumbmit() {
			this.trigger.keluargaKatolik = !this.trigger.keluargaKatolik;
			console.log("trigger Suami");
		},
		async validateKeluargaKatolik(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Data Keluarga Katolik belum lengkap");
				} else {
					console.log("onSubmit");
					this.onSubmit();
				}
			});
		},
		onSubmit() {
			const isKepala = this.keluargaKatolikAnggota.find(
				(item) => item.is_kepala == 1
			);
         // console.log(isKepala)
         
			if (!isKepala) {
				this.$toast.error("Kepala keluarga Belum ada");
				return;
			}
         
         // SET NAMA KEPALA KELUARGA
         this.keluargaKatolikItem.nama_kepala = isKepala.nama;
         
			const data = {
				anggota: this.keluargaKatolikAnggota,
				keluarga_katolik: this.keluargaKatolikItem,
			};

			if (this.mode === "INSERT") {
				this.insert(data).then(() => {
					this.$router.push("/keluarga_katolik");
				});
			} else {
				this.update(data).then(() => {
					this.$router.push("/keluarga_katolik");
				});
			}
		},
		onSubmitAnggota() {
			if (!this.anggota.hubungan_keluarga) {
				this.$toast.error("Hubungan Belum diisi");
				return;
			}
         
         // CHECK DUPLICATE UMAT
			if (
				this.keluargaKatolikAnggota.find(
					(item) => item.umat_uid == this.anggota.uid
				)
			) {
				this.$toast.error("Umat ini sudah menjadi anggota");
				return;
			}

			// CHECK KEPALA KELUARGA
			let isKepala = 0;
			const isKepalaKeluarga = this.keluargaKatolikAnggota.find(
				(item) => item.is_kepala == 1
			);
			if (!isKepalaKeluarga) isKepala = 1;

			const _anggota = {
				kk_uid: this.keluargaKatolikItem.uid,
				umat_uid: this.anggota.uid,
				hubungan: this.anggota.hubungan_keluarga,
				is_kepala: isKepala,
				nama: this.anggota.nama,
				jk: this.anggota.jk,
				pendidikan: this.anggota.pendidikan,
				pekerjaan: this.anggota.pekerjaan,
				agama: this.anggota.agama,
				tempat_lahir: this.anggota.tempat_lahir,
				tgl_lahir: this.anggota.tgl_lahir,
			};
			this.addAnggota(_anggota);
			this.$bvModal.hide("bv-modal-anggota");
		},
		onDeleteAnggota(uid) {
			console.log(uid);
			this.deleteAnggota(uid);
		},
		onChangeKepala(uid) {
			console.log(uid);
			this.setKepala(uid);
		},
		onCancel() {
			this.$modal.hide("umatModal");
		},
		onRowClick(uid) {
			this.getItemUmat(uid).then((response) => {
				const umat = response.data.umat;
            
            // CHECKING
            if(umat.is_kk){
               this.$toast.error("Umat ini sudah menjadi anggota keluarga lain.");
               return
            }
            
				this.anggota = umat;
				this.$modal.hide("umatModal");
				this.$bvModal.show("bv-modal-anggota");
			});
		},
		onShowUmat() {
			this.$modal.show("umatModal");
		},
		autoFill() {
			this.keluargaKatolikItem.no_buku_lm = "";
			this.keluargaKatolikItem.no_lm = "";
			this.keluargaKatolikItem.tgl_perkawinan = "";

			this.keluargaKatolikItem.keuskupan_lm = "Keuskupan Sintang";
			this.keluargaKatolikItem.paroki_lm =
				"Paroki Katedral Kristus Raja Sintang";
			this.keluargaKatolikItem.wali = this.$faker().name.findName();
			this.keluargaKatolikItem.wali2 = this.$faker().name.findName();
			this.keluargaKatolikItem.imam_peneguh = this.$faker().name.findName();
		},
	},
};
</script>

<template>
	<div>
		<vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
		</vue-fab>

		<Breadcrumbs main="Keluarga Katolik" title="Form Keluarga Katolik" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Data Keluarga Katolik :</h5>
							<hr />
							<comp-keluarga-katolik
								@validate="validateKeluargaKatolik"
								:triggerValidation="trigger.keluargaKatolik"
							></comp-keluarga-katolik>
						</div>
					</px-card>
				</div>
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Anggota Keluarga Katolik :</h5>
							<hr />
							<b-button variant="primary" size="sm" @click="onShowUmat"
								><i class="fa fa-plus"></i> Tambah Anggota</b-button
							>
							<div class="table-responsive invoice-table">
								<table class="table table-bordered table-striped">
									<thead class="thead-light">
										<tr>
											<th class="text-center">No.</th>
											<th class="text-center">Nama</th>
											<th class="text-center">L/P</th>
											<th class="text-center">Hubungan Keluarga</th>

											<th class="text-center">Kepala Keluarga</th>
											<th class="text-center">Action</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(item, index) in keluargaKatolikAnggota"
											:key="item.umat_uid"
										>
											<td class="text-center">{{ index + 1 }}</td>
											<td>{{ item.nama }}</td>
											<td class="text-center">{{ item.jk }}</td>
											<td>{{ item.hubungan }}</td>

											<td class="text-center">
												<input
													class="radio_animated"
													:checked="item.is_kepala == 1"
													type="radio"
													value="1"
													@click="onChangeKepala(item.umat_uid)"
												/>
											</td>
											<td class="text-center">
												<b-btn-group>
													<b-button
														size="xs"
														variant="danger"
														@click="
															onDeleteAnggota(item.umat_uid)
														"
														v-b-tooltip.hover
														title="Delete"
													>
														<i class="fa fa-times"></i>
													</b-button>
												</b-btn-group>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</px-card>
				</div>
			</div>
		</div>

		<modal name="umatModal" width="80%" height="80%" :clickToClose="false">
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancel()"
									v-b-tooltip.hover
									title="Tambah"
									size="sm"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-umat-modal @onRowClick="onRowClick" />
						</div>
					</div>
				</div>
			</template>
		</modal>

		<b-modal id="bv-modal-anggota" hide-footer>
			<template #modal-title> Form Hubungan Keluarga </template>
			<form
				class="theme-form"
				@submit.prevent="onSubmitAnggota"
				id="form-data"
			>
				<div class="row">
					<div class="col-md-12">
						<table width="100%">
							<tbody>
								<tr>
									<td width="20%"><b>Nama</b></td>
									<td width="2%">:</td>
									<td width="50%">
										{{ anggota.nama }}
									</td>
								</tr>
								<tr>
									<td><b>L/P</b></td>
									<td>:</td>
									<td>
										{{ anggota.jk }}
									</td>
								</tr>
								<tr>
									<td><b>TTL</b></td>
									<td>:</td>
									<td>
										{{ anggota.tempat_lahir }},
										{{
											$moment(anggota.tgl_lahir).format(
												"DD MMMM YYYY"
											)
										}}
									</td>
								</tr>
								<tr>
									<td><b>Agama</b></td>
									<td>:</td>
									<td>{{ anggota.agama }}</td>
								</tr>
								<tr>
									<td><b>Pendidikan</b></td>
									<td>:</td>
									<td>{{ anggota.pendidikan }}</td>
								</tr>
								<tr>
									<td><b>Pekerjaan</b></td>
									<td>:</td>
									<td>{{ anggota.pekerjaan }}</td>
								</tr>
							</tbody>
						</table>
						<hr />
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label
								>Hubungan Keluarga
								<span class="text-danger">*</span></label
							>
							<vue-typeahead-bootstrap
								name="hubungan"
								:minMatchingChars="1"
								size="sm"
								v-model="anggota.hubungan_keluarga"
								:data="myOptions.hubungan"
							/>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<button
								class="btn btn-primary btn-block"
								type="submit"
								form="form-data"
							>
								Simpan
							</button>
						</div>
					</div>
				</div>
			</form>
		</b-modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>